import { render, staticRenderFns } from "./IndigenousAchievements.vue?vue&type=template&id=7626a744&scoped=true&"
import script from "./IndigenousAchievements.vue?vue&type=script&lang=js&"
export * from "./IndigenousAchievements.vue?vue&type=script&lang=js&"
import style0 from "./IndigenousAchievements.vue?vue&type=style&index=0&id=7626a744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7626a744",
  null
  
)

export default component.exports